import { render } from "./ShiftViewToggleButton.vue?vue&type=template&id=0355d304&scoped=true"
import script from "./ShiftViewToggleButton.vue?vue&type=script&lang=js"
export * from "./ShiftViewToggleButton.vue?vue&type=script&lang=js"

import "./ShiftViewToggleButton.vue?vue&type=style&index=0&id=0355d304&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0355d304"]])

export default __exports__